// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ticket-container {
    color: aliceblue;
    column-gap: 5px;
    position: absolute;
    height: calc(100% - 60px)!important;
}

.ticketing-layout .MuiGrid-root{
    /* position: absolute; */
    height: 100%;
}


.ticket-container > div > div {
    height: 100%;
    gap: 5px;
    display: flex;
    flex-direction: column;
}
.ticket-card {
    justify-content: center;
    /* position: relative; merge test */
    display: grid;
    width: auto;
}

.filterTickets button {
    background: linear-gradient(90deg, rgba(73, 150, 238) 0%, rgba(37, 75, 119) 100%);
    color: #fff;
    width: 100%;
    border-radius: 0 !important;
}

.filterTickets button:hover {
    background: linear-gradient(90deg, rgba(37, 75, 119) 0%, rgba(73, 150, 238) 100%);
}

.submitFilters {
    background: linear-gradient(90deg, rgba(73, 150, 238) 0%, rgba(37, 75, 119) 100%);
    color: #fff;

    margin-bottom: 20px;

    border-radius: 0 !important;
}

.submitFilters:hover {
    background: linear-gradient(90deg, rgba(37, 75, 119) 0%, rgba(73, 150, 238) 100%);
}
.column {
    width: 100%;
}
.ticketColumn {

    text-align: center;
    gap: 5px;
    display: grid;
    width: 100%;
    /* position: relative;
    height: 70vh; merge test */
    overflow-y: scroll;
}

.ticketColumn2 {

    text-align: center;
    position: relative;
    height: 70vh;
    overflow-y: scroll;
}

.ticketColumn3 {

    text-align: center;
    position: relative;
    height: 70vh;
    overflow-y: scroll;
}

.ticketColumn4 {


    text-align: center;
    position: relative;
    height: 70vh;
    overflow-y: scroll;
}

.ticketColumn2 {

    text-align: center;
    position: relative;
    height: 70vh;
    overflow-y: scroll;
}

.ticketColumn3 {

    text-align: center;
    position: relative;
    height: 70vh;
    overflow-y: scroll;
}

.ticketColumn4 {

    text-align: center;
    position: relative;
    height: 70vh;
    overflow-y: scroll;
}


.ticketColumn::-webkit-scrollbar {
    width: 5px !important;
}

.ticketColumn2::-webkit-scrollbar {
    width: 5px !important;
}

.ticketColumn3::-webkit-scrollbar {
    width: 5px !important;
}

.ticketColumn4::-webkit-scrollbar {
    width: 5px !important;
}

.paperContainer .MuiPaper-root {
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    margin: 0 auto;
}

.dialogueButtons {
    text-align: right;
    margin-top: 10px;

}

.dialogueButtons button {
    background: linear-gradient(90deg, rgba(73, 150, 238) 0%, rgba(37, 75, 119) 100%);
    color: #fff;
    margin-right: 5px;
    width: 100px;
    border-radius: 0 !important;
}

.dialogueButtons button:hover {
    background: linear-gradient(90deg, rgba(37, 75, 119) 0%, rgba(73, 150, 238) 100%);
    color: #fff;
}

.dialougeForm input {
    border: 1px solid #ccc;
    color: #ccc;
    font-size: 18px;
    background-color: #282B30;
    border-radius: 0 !important;
}

.dialougeForm .MuiInputBase-root {
    border: 1px solid #ccc;
    color: #ccc;
    background-color: #282B30;
    border-radius: 0 !important;
}

.dialougeForm .MuiFormControl-root {
    margin-top: 2px;
    margin-bottom: 10px;
}



.columnTitle {
    width: 100%;
    height: 30px;
    text-align: center;
    background-color: #282B30;
    font-size: 16px;
    padding: 5px 0;
    font-weight: bold;
    display: flex;
    justify-content: center;
    align-items: center;
}

.ticketCount {
    border-radius: 50%;
    background-color: #121314;
    font-size: 16px;
    margin-left: 5px;
    width: 30px;
    height: 29px;
    display: flex;
    justify-content: center;
    align-items: center;
    padding-bottom: 1px;
}

.ticket-card {
    background-color: #282b30da;
    padding: 3px;
}

.cardTitle {
    font-size: 20px;
    width: 95%;
    overflow: hidden;
    height: 30px;
}

.cardDescription {
    margin-top: 10px;
    /* height: 20px;
    width: 95%;
    overflow: hidden;
    max-width: 180px;
    margin-bottom: 5px; */
}



.cardPriority {
    display: flow-root;
    font-size: 14px;
    margin: 10px 0;
}

.cardDate {
    margin-top: 5px;
    display: flow-root;
    font-size: 14px;
}

.cardOpen {
    display: inline-block;
    width: 48%;
    text-align: right;
    padding: 1px;
}

.cardAction {
    width: 48%;
    display: inline-block;
    padding: 1px;
}

.cardAction button {
    width: 90px !important;
    background: linear-gradient(90deg, rgba(73, 150, 238) 0%, rgba(37, 75, 119) 100%);
    color: #fff;
    height: 20px;
    border-radius: 0 !important;
    font-size: 12px;
}

.cardAction button:hover {
    background: linear-gradient(90deg, rgba(37, 75, 119) 0%, rgba(73, 150, 238) 100%);
    color: #fff;
}

.cardOpen button {
    width: 90px !important;
    background: linear-gradient(90deg, rgba(73, 150, 238) 0%, rgba(37, 75, 119) 100%);
    color: #fff;
    height: 20px;
    border-radius: 0 !important;
    font-size: 12px;

}

.cardOpen button:hover {
    background: linear-gradient(90deg, rgba(37, 75, 119) 0%, rgba(73, 150, 238) 100%);
    color: #fff;
}

.MuiDialog-root .MuiDialog-container .css-1t1j96h-MuiPaper-root-MuiDialog-paper {
    background-color: #0F0E17 !important;
    z-index: 9;
    position: absolute;
    display: flex;
}

.css-9ddj71-MuiInputBase-root-MuiOutlinedInput-root {
    color: #fff !important;
}

.css-1t8l2tu-MuiInputBase-input-MuiOutlinedInput-input {
    padding: 3px 15px !important;
    color: #fff !important;

}

.filterItems {
    margin-top: 20px;
    display: flex;
}

.filterItems > div {
    width: 75%;
}

.filterItems > div > div {
    overflow: visible !important;
    overflow-x: visible !important;
    max-width: 100% !important;
}

.css-11u53oe-MuiSelect-select-MuiInputBase-input-MuiOutlinedInput-input {
    padding: 2px 30px !important;
    color: #fff !important;
    overflow-x: hidden;
    max-width: 110px !important;
}

.filterItems .css-1e8dhvr-MuiChip-root {
    color: #fff !important;
    padding-right: 10px;
}

.filterItems .css-hfutr2-MuiSvgIcon-root-MuiSelect-icon {
    color: #fff !important;
}

.css-1d3z3hw-MuiOutlinedInput-notchedOutline > * {
    border-color: #acabab !important;
    border-radius: 0 !important;
    color: #fff !important;
}

.addNewTicket button {
    background: linear-gradient(90deg, rgba(73, 150, 238) 0%, rgba(37, 75, 119) 100%);
    color: #fff;
    border-radius: 0 !important;
    text-align: left;
    align-items: left;
    height: 38px;
}

.addNewTicket button:hover {
    background: linear-gradient(90deg, rgba(37, 75, 119) 0%, rgba(73, 150, 238) 100%);
    color: #fff;
}

.searchBar input[type='text'] {
    padding: 0;
    padding-left: 15px;
    margin-bottom: 0;
    border: 1px solid #ccc;
    border-radius: 0 !important;
    background-color: #282B30;
    color: #e1e1e1;
}
 .buttons-bar > div > .sortBy .MuiFormControl-root {
    height: 40px !important;
    color: #ccc;
    border: 1px solid #ccc;
}

.buttons-bar > div > .sortBy .MuiFormControl-root .MuiInputBase-root {
    height: 40px !important;
    color: #ccc;
    background-color: #282B30;
    font-size: 14px;
}

.sortBy .MuiFormControl-root .MuiFormLabel-root {
    visibility: hidden;
}

.priority {
    padding: 5px 10px;
    width: 60px;
    border-radius: 60px;
    height: 20px !important;
    text-align: center;
}

.priority.critical {
    background-color: rgb(80, 31, 31);
    height: 20px !important;
    animation: blinker 1s linear infinite;
    
}


.priority.open.alarm {
    background-color: rgb(184, 70, 70);
    height: 20px !important;
    animation: blinker 1s linear infinite;
}
@keyframes blinker {
    50% {
        opacity: 0;
    }
}

.priority.progress.alarm {
    background-color: rgb(184, 70, 70);
    height: 20px !important;
}
.priority.approval.alarm {
    background-color: rgb(202, 200, 50);
    height: 20px !important;
}
.priority.closed.alarm {
    background-color: rgb(0, 135, 13);
    height: 20px !important;
}

.priority.closed.warning {
    background-color: rgb(0, 135, 13);
    height: 20px !important;
}
.priority.warning{
    background-color: rgb(138, 135, 59);
    height: 20px !important;
}



.priority.medium {
    background-color: rgb(206, 155, 62);
}

.priority.low {
    background-color: rgb(132, 132, 42);
}

.selected .priority {
    color: #fff;
}

.selected .priority.high {
    background-color: rgb(184, 70, 70);
}

.selected .priority.medium {
    background-color: rgb(206, 155, 62);
}

.selected .priority.low {
    background-color: rgb(224, 224, 83);
}

.closeDialog button {
    background: linear-gradient(90deg, rgba(73, 150, 238) 0%, rgba(37, 75, 119) 100%);
    color: #fff;
    border-radius: 0 !important;
}

.closeDialog button:hover {
    background: linear-gradient(90deg, rgba(37, 75, 119) 0%, rgba(73, 150, 238) 100%);
    color: #fff;
}

.sortBy .MuiFormControl-root .MuiInputBase-root .css-11u53oe-MuiSelect-select-MuiInputBase-input-MuiOutlinedInput-input {
    padding-top: 0 !important;
    padding-bottom: 0 !important;
}

.MuiPopover-root .css-1ka5eyc-MuiPaper-root-MuiMenu-paper-MuiPopover-paper {
    background-color: #282B30 !important;
    color: #ccc;
}

.ticket-container .css-mhc70k-MuiGrid-root>.MuiGrid-item {
    padding-left: 0 !important;
}

@media screen and (max-width: 1265px) and (min-width: 1165px) {
    .addNewTicket button {
        /* width: 140px !important; */
        font-size: 12px;
        text-align: center;
    }
}

@media screen and (max-width: 1164px) and (min-width: 1000px) {
    .addNewTicket button {
        width: 120px;
        font-size: 9px;
        text-align: center;
    }
}

@media screen and (max-width: 1000px) and (min-width: 805px) {
    .addNewTicket button {

        font-size: 8px;
        text-align: center;
    }

    .TicketingPage {
        width: 100%;

    }

    .layoutContainer {
        width: 100%;
    }
}

@media screen and (max-width: 805px) and (min-width: 625px) {
    .addNewTicket button {
        width: 50px;
        font-size: 6px;
        text-align: center;
    }

}

@media screen and (max-width: 1050px) and (min-width: 625px) {
   
    .cardPriority {
        display: flow-root;
        margin-top: 5px;
        width: auto;
        text-align: center;
    }

    .cardDate {
        display: flex;
        width: auto;
    }

    .cardOpen {
        display: block;
        text-align: center;
    }

    .cardAction {
        display: block;
        text-align: center;
    }

    .cardButtons {
        justify-content: center;
        align-items: center;
        position: relative;
        display: grid;
        width: auto;
    }

    .cardDetails {
        justify-content: center;
        align-items: center;

        display: grid;

    }

    .columnTitle {
        font-size: 12px;
    }

    .ticketCount {
        font-size: 8px;
    }
}

@media screen and (max-width: 625px) {

    .cardPriority {
        display: flow-root;
        margin-top: 5px;
        width: auto;
        text-align: center;
    }

    .cardDate {
        display: flex;
        width: auto;
    }

    .ticket-card {
        text-align: center;
    }

    .cardOpen {
        display: block;
        text-align: center;
    }

    .cardAction {
        display: block;
        text-align: center;
    }

    .cardButtons {
        justify-content: center;
        align-items: center;
        position: relative;
        display: grid;
        width: auto;
    }

    .cardDetails {
        justify-content: center;
        align-items: center;

        display: grid;

    }

    .columnTitle {
        font-size: 12px;
    }

    .ticketCount {
        font-size: 8px;
    }



    .navb nav ul {
        width: 100% !important;
    }

    .navb {
        width: 100%;
    }

    .layoutContainer {
        width: 120%;
    }
}

@media screen and (max-width: 899px) {
    .navb nav ul li {
        display: inline-block;
    }

    .layoutContainer {
        width: 120%;
    }


}

@media screen and (min-width:768px) {
    .MuiGrid-root.MuiGrid-grid-xs-12.MuiGrid-grid-sm-6.MuiGrid-grid-md-3.css-10voxkt-MuiGrid-root {
        max-width: calc(25% - 5px);
    }
}

@media screen and (max-width:768px) {
    .MuiGrid-root.MuiGrid-grid-xs-12.MuiGrid-grid-sm-6.MuiGrid-grid-md-3.css-10voxkt-MuiGrid-root {
        max-width: calc(50% - 5px);
    }
    
    /* .ticketing-layout {
        width: calc(100% - 2rem) !important;
    
    } */
}


@media screen and (min-width: 899px) {

    .layoutContainer {
        width: 100% !important;
    }

    .addNewTicket button {

        text-align: center;
    }


}

@media screen and (min-width: 1050px) {
    .cardAction button {
        margin: 2px;
    }
}

@media screen and (max-width: 1165px) {
    .addNewTicket button {
        height: 38px !important;
        font-size: 12px;
        text-align: center;
        width: 98%;
        margin-bottom: 15px;
    }

}

@media screen and (max-width: 600px) {
    .firstPart {
        display: inline-block;
    }

    .cardDescription {
        display: inline-block;
    }

    .buttonsDetails {
        display: inline-block;
    }

}

.ticketing-layout {
    position: relative;
    height: calc(100% - 6rem);
    /* min-height: 500px; */
    /* width: calc(100% - 2rem) !important; */

}
.TicketingPage{
    height: 100%;
    position: relative;
}

.navb-item{
    height: auto !important;
}

.TicketingPage > .buttons-bar {
    padding-bottom: 10px;
    height: auto;
}

.TicketingPage > .buttons-bar > div, .TicketingPage > .buttons-bar > div > *, .TicketingPage > .buttons-bar > div > div > * {
    width: 100% !important;
    width: -webkit-fill-available !important;
    width: -moz-available !important;
    height: 40px !important;
    margin-bottom: 10px;
}

.TicketingPage .buttons-bar button , .TicketingPage .buttons-bar input, .TicketingPage .buttons-bar select  {
    width: 100% !important;
    height: 40px !important;
    width: -webkit-fill-available !important;
    width: -moz-available !important;
}`, "",{"version":3,"sources":["webpack://./src/components/TicketingComponents/Board.css"],"names":[],"mappings":"AAAA;IACI,gBAAgB;IAChB,eAAe;IACf,kBAAkB;IAClB,mCAAmC;AACvC;;AAEA;IACI,wBAAwB;IACxB,YAAY;AAChB;;;AAGA;IACI,YAAY;IACZ,QAAQ;IACR,aAAa;IACb,sBAAsB;AAC1B;AACA;IACI,uBAAuB;IACvB,mCAAmC;IACnC,aAAa;IACb,WAAW;AACf;;AAEA;IACI,iFAAiF;IACjF,WAAW;IACX,WAAW;IACX,2BAA2B;AAC/B;;AAEA;IACI,iFAAiF;AACrF;;AAEA;IACI,iFAAiF;IACjF,WAAW;;IAEX,mBAAmB;;IAEnB,2BAA2B;AAC/B;;AAEA;IACI,iFAAiF;AACrF;AACA;IACI,WAAW;AACf;AACA;;IAEI,kBAAkB;IAClB,QAAQ;IACR,aAAa;IACb,WAAW;IACX;8BAC0B;IAC1B,kBAAkB;AACtB;;AAEA;;IAEI,kBAAkB;IAClB,kBAAkB;IAClB,YAAY;IACZ,kBAAkB;AACtB;;AAEA;;IAEI,kBAAkB;IAClB,kBAAkB;IAClB,YAAY;IACZ,kBAAkB;AACtB;;AAEA;;;IAGI,kBAAkB;IAClB,kBAAkB;IAClB,YAAY;IACZ,kBAAkB;AACtB;;AAEA;;IAEI,kBAAkB;IAClB,kBAAkB;IAClB,YAAY;IACZ,kBAAkB;AACtB;;AAEA;;IAEI,kBAAkB;IAClB,kBAAkB;IAClB,YAAY;IACZ,kBAAkB;AACtB;;AAEA;;IAEI,kBAAkB;IAClB,kBAAkB;IAClB,YAAY;IACZ,kBAAkB;AACtB;;;AAGA;IACI,qBAAqB;AACzB;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,8BAA8B;IAC9B,cAAc;AAClB;;AAEA;IACI,iBAAiB;IACjB,gBAAgB;;AAEpB;;AAEA;IACI,iFAAiF;IACjF,WAAW;IACX,iBAAiB;IACjB,YAAY;IACZ,2BAA2B;AAC/B;;AAEA;IACI,iFAAiF;IACjF,WAAW;AACf;;AAEA;IACI,sBAAsB;IACtB,WAAW;IACX,eAAe;IACf,yBAAyB;IACzB,2BAA2B;AAC/B;;AAEA;IACI,sBAAsB;IACtB,WAAW;IACX,yBAAyB;IACzB,2BAA2B;AAC/B;;AAEA;IACI,eAAe;IACf,mBAAmB;AACvB;;;;AAIA;IACI,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,yBAAyB;IACzB,eAAe;IACf,cAAc;IACd,iBAAiB;IACjB,aAAa;IACb,uBAAuB;IACvB,mBAAmB;AACvB;;AAEA;IACI,kBAAkB;IAClB,yBAAyB;IACzB,eAAe;IACf,gBAAgB;IAChB,WAAW;IACX,YAAY;IACZ,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,mBAAmB;AACvB;;AAEA;IACI,2BAA2B;IAC3B,YAAY;AAChB;;AAEA;IACI,eAAe;IACf,UAAU;IACV,gBAAgB;IAChB,YAAY;AAChB;;AAEA;IACI,gBAAgB;IAChB;;;;yBAIqB;AACzB;;;;AAIA;IACI,kBAAkB;IAClB,eAAe;IACf,cAAc;AAClB;;AAEA;IACI,eAAe;IACf,kBAAkB;IAClB,eAAe;AACnB;;AAEA;IACI,qBAAqB;IACrB,UAAU;IACV,iBAAiB;IACjB,YAAY;AAChB;;AAEA;IACI,UAAU;IACV,qBAAqB;IACrB,YAAY;AAChB;;AAEA;IACI,sBAAsB;IACtB,iFAAiF;IACjF,WAAW;IACX,YAAY;IACZ,2BAA2B;IAC3B,eAAe;AACnB;;AAEA;IACI,iFAAiF;IACjF,WAAW;AACf;;AAEA;IACI,sBAAsB;IACtB,iFAAiF;IACjF,WAAW;IACX,YAAY;IACZ,2BAA2B;IAC3B,eAAe;;AAEnB;;AAEA;IACI,iFAAiF;IACjF,WAAW;AACf;;AAEA;IACI,oCAAoC;IACpC,UAAU;IACV,kBAAkB;IAClB,aAAa;AACjB;;AAEA;IACI,sBAAsB;AAC1B;;AAEA;IACI,4BAA4B;IAC5B,sBAAsB;;AAE1B;;AAEA;IACI,gBAAgB;IAChB,aAAa;AACjB;;AAEA;IACI,UAAU;AACd;;AAEA;IACI,4BAA4B;IAC5B,8BAA8B;IAC9B,0BAA0B;AAC9B;;AAEA;IACI,4BAA4B;IAC5B,sBAAsB;IACtB,kBAAkB;IAClB,2BAA2B;AAC/B;;AAEA;IACI,sBAAsB;IACtB,mBAAmB;AACvB;;AAEA;IACI,sBAAsB;AAC1B;;AAEA;IACI,gCAAgC;IAChC,2BAA2B;IAC3B,sBAAsB;AAC1B;;AAEA;IACI,iFAAiF;IACjF,WAAW;IACX,2BAA2B;IAC3B,gBAAgB;IAChB,iBAAiB;IACjB,YAAY;AAChB;;AAEA;IACI,iFAAiF;IACjF,WAAW;AACf;;AAEA;IACI,UAAU;IACV,kBAAkB;IAClB,gBAAgB;IAChB,sBAAsB;IACtB,2BAA2B;IAC3B,yBAAyB;IACzB,cAAc;AAClB;CACC;IACG,uBAAuB;IACvB,WAAW;IACX,sBAAsB;AAC1B;;AAEA;IACI,uBAAuB;IACvB,WAAW;IACX,yBAAyB;IACzB,eAAe;AACnB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,iBAAiB;IACjB,WAAW;IACX,mBAAmB;IACnB,uBAAuB;IACvB,kBAAkB;AACtB;;AAEA;IACI,iCAAiC;IACjC,uBAAuB;IACvB,qCAAqC;;AAEzC;;;AAGA;IACI,kCAAkC;IAClC,uBAAuB;IACvB,qCAAqC;AACzC;AACA;IACI;QACI,UAAU;IACd;AACJ;;AAEA;IACI,kCAAkC;IAClC,uBAAuB;AAC3B;AACA;IACI,mCAAmC;IACnC,uBAAuB;AAC3B;AACA;IACI,iCAAiC;IACjC,uBAAuB;AAC3B;;AAEA;IACI,iCAAiC;IACjC,uBAAuB;AAC3B;AACA;IACI,mCAAmC;IACnC,uBAAuB;AAC3B;;;;AAIA;IACI,mCAAmC;AACvC;;AAEA;IACI,mCAAmC;AACvC;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,kCAAkC;AACtC;;AAEA;IACI,mCAAmC;AACvC;;AAEA;IACI,mCAAmC;AACvC;;AAEA;IACI,iFAAiF;IACjF,WAAW;IACX,2BAA2B;AAC/B;;AAEA;IACI,iFAAiF;IACjF,WAAW;AACf;;AAEA;IACI,yBAAyB;IACzB,4BAA4B;AAChC;;AAEA;IACI,oCAAoC;IACpC,WAAW;AACf;;AAEA;IACI,0BAA0B;AAC9B;;AAEA;IACI;QACI,6BAA6B;QAC7B,eAAe;QACf,kBAAkB;IACtB;AACJ;;AAEA;IACI;QACI,YAAY;QACZ,cAAc;QACd,kBAAkB;IACtB;AACJ;;AAEA;IACI;;QAEI,cAAc;QACd,kBAAkB;IACtB;;IAEA;QACI,WAAW;;IAEf;;IAEA;QACI,WAAW;IACf;AACJ;;AAEA;IACI;QACI,WAAW;QACX,cAAc;QACd,kBAAkB;IACtB;;AAEJ;;AAEA;;IAEI;QACI,kBAAkB;QAClB,eAAe;QACf,WAAW;QACX,kBAAkB;IACtB;;IAEA;QACI,aAAa;QACb,WAAW;IACf;;IAEA;QACI,cAAc;QACd,kBAAkB;IACtB;;IAEA;QACI,cAAc;QACd,kBAAkB;IACtB;;IAEA;QACI,uBAAuB;QACvB,mBAAmB;QACnB,kBAAkB;QAClB,aAAa;QACb,WAAW;IACf;;IAEA;QACI,uBAAuB;QACvB,mBAAmB;;QAEnB,aAAa;;IAEjB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,cAAc;IAClB;AACJ;;AAEA;;IAEI;QACI,kBAAkB;QAClB,eAAe;QACf,WAAW;QACX,kBAAkB;IACtB;;IAEA;QACI,aAAa;QACb,WAAW;IACf;;IAEA;QACI,kBAAkB;IACtB;;IAEA;QACI,cAAc;QACd,kBAAkB;IACtB;;IAEA;QACI,cAAc;QACd,kBAAkB;IACtB;;IAEA;QACI,uBAAuB;QACvB,mBAAmB;QACnB,kBAAkB;QAClB,aAAa;QACb,WAAW;IACf;;IAEA;QACI,uBAAuB;QACvB,mBAAmB;;QAEnB,aAAa;;IAEjB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,cAAc;IAClB;;;;IAIA;QACI,sBAAsB;IAC1B;;IAEA;QACI,WAAW;IACf;;IAEA;QACI,WAAW;IACf;AACJ;;AAEA;IACI;QACI,qBAAqB;IACzB;;IAEA;QACI,WAAW;IACf;;;AAGJ;;AAEA;IACI;QACI,0BAA0B;IAC9B;AACJ;;AAEA;IACI;QACI,0BAA0B;IAC9B;;IAEA;;;OAGG;AACP;;;AAGA;;IAEI;QACI,sBAAsB;IAC1B;;IAEA;;QAEI,kBAAkB;IACtB;;;AAGJ;;AAEA;IACI;QACI,WAAW;IACf;AACJ;;AAEA;IACI;QACI,uBAAuB;QACvB,eAAe;QACf,kBAAkB;QAClB,UAAU;QACV,mBAAmB;IACvB;;AAEJ;;AAEA;IACI;QACI,qBAAqB;IACzB;;IAEA;QACI,qBAAqB;IACzB;;IAEA;QACI,qBAAqB;IACzB;;AAEJ;;AAEA;IACI,kBAAkB;IAClB,yBAAyB;IACzB,uBAAuB;IACvB,yCAAyC;;AAE7C;AACA;IACI,YAAY;IACZ,kBAAkB;AACtB;;AAEA;IACI,uBAAuB;AAC3B;;AAEA;IACI,oBAAoB;IACpB,YAAY;AAChB;;AAEA;IACI,sBAAsB;IACtB,wCAAwC;IACxC,gCAAgC;IAChC,uBAAuB;IACvB,mBAAmB;AACvB;;AAEA;IACI,sBAAsB;IACtB,uBAAuB;IACvB,wCAAwC;IACxC,gCAAgC;AACpC","sourcesContent":[".ticket-container {\n    color: aliceblue;\n    column-gap: 5px;\n    position: absolute;\n    height: calc(100% - 60px)!important;\n}\n\n.ticketing-layout .MuiGrid-root{\n    /* position: absolute; */\n    height: 100%;\n}\n\n\n.ticket-container > div > div {\n    height: 100%;\n    gap: 5px;\n    display: flex;\n    flex-direction: column;\n}\n.ticket-card {\n    justify-content: center;\n    /* position: relative; merge test */\n    display: grid;\n    width: auto;\n}\n\n.filterTickets button {\n    background: linear-gradient(90deg, rgba(73, 150, 238) 0%, rgba(37, 75, 119) 100%);\n    color: #fff;\n    width: 100%;\n    border-radius: 0 !important;\n}\n\n.filterTickets button:hover {\n    background: linear-gradient(90deg, rgba(37, 75, 119) 0%, rgba(73, 150, 238) 100%);\n}\n\n.submitFilters {\n    background: linear-gradient(90deg, rgba(73, 150, 238) 0%, rgba(37, 75, 119) 100%);\n    color: #fff;\n\n    margin-bottom: 20px;\n\n    border-radius: 0 !important;\n}\n\n.submitFilters:hover {\n    background: linear-gradient(90deg, rgba(37, 75, 119) 0%, rgba(73, 150, 238) 100%);\n}\n.column {\n    width: 100%;\n}\n.ticketColumn {\n\n    text-align: center;\n    gap: 5px;\n    display: grid;\n    width: 100%;\n    /* position: relative;\n    height: 70vh; merge test */\n    overflow-y: scroll;\n}\n\n.ticketColumn2 {\n\n    text-align: center;\n    position: relative;\n    height: 70vh;\n    overflow-y: scroll;\n}\n\n.ticketColumn3 {\n\n    text-align: center;\n    position: relative;\n    height: 70vh;\n    overflow-y: scroll;\n}\n\n.ticketColumn4 {\n\n\n    text-align: center;\n    position: relative;\n    height: 70vh;\n    overflow-y: scroll;\n}\n\n.ticketColumn2 {\n\n    text-align: center;\n    position: relative;\n    height: 70vh;\n    overflow-y: scroll;\n}\n\n.ticketColumn3 {\n\n    text-align: center;\n    position: relative;\n    height: 70vh;\n    overflow-y: scroll;\n}\n\n.ticketColumn4 {\n\n    text-align: center;\n    position: relative;\n    height: 70vh;\n    overflow-y: scroll;\n}\n\n\n.ticketColumn::-webkit-scrollbar {\n    width: 5px !important;\n}\n\n.ticketColumn2::-webkit-scrollbar {\n    width: 5px !important;\n}\n\n.ticketColumn3::-webkit-scrollbar {\n    width: 5px !important;\n}\n\n.ticketColumn4::-webkit-scrollbar {\n    width: 5px !important;\n}\n\n.paperContainer .MuiPaper-root {\n    display: flex;\n    flex-direction: column;\n    justify-content: space-between;\n    margin: 0 auto;\n}\n\n.dialogueButtons {\n    text-align: right;\n    margin-top: 10px;\n\n}\n\n.dialogueButtons button {\n    background: linear-gradient(90deg, rgba(73, 150, 238) 0%, rgba(37, 75, 119) 100%);\n    color: #fff;\n    margin-right: 5px;\n    width: 100px;\n    border-radius: 0 !important;\n}\n\n.dialogueButtons button:hover {\n    background: linear-gradient(90deg, rgba(37, 75, 119) 0%, rgba(73, 150, 238) 100%);\n    color: #fff;\n}\n\n.dialougeForm input {\n    border: 1px solid #ccc;\n    color: #ccc;\n    font-size: 18px;\n    background-color: #282B30;\n    border-radius: 0 !important;\n}\n\n.dialougeForm .MuiInputBase-root {\n    border: 1px solid #ccc;\n    color: #ccc;\n    background-color: #282B30;\n    border-radius: 0 !important;\n}\n\n.dialougeForm .MuiFormControl-root {\n    margin-top: 2px;\n    margin-bottom: 10px;\n}\n\n\n\n.columnTitle {\n    width: 100%;\n    height: 30px;\n    text-align: center;\n    background-color: #282B30;\n    font-size: 16px;\n    padding: 5px 0;\n    font-weight: bold;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n}\n\n.ticketCount {\n    border-radius: 50%;\n    background-color: #121314;\n    font-size: 16px;\n    margin-left: 5px;\n    width: 30px;\n    height: 29px;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    padding-bottom: 1px;\n}\n\n.ticket-card {\n    background-color: #282b30da;\n    padding: 3px;\n}\n\n.cardTitle {\n    font-size: 20px;\n    width: 95%;\n    overflow: hidden;\n    height: 30px;\n}\n\n.cardDescription {\n    margin-top: 10px;\n    /* height: 20px;\n    width: 95%;\n    overflow: hidden;\n    max-width: 180px;\n    margin-bottom: 5px; */\n}\n\n\n\n.cardPriority {\n    display: flow-root;\n    font-size: 14px;\n    margin: 10px 0;\n}\n\n.cardDate {\n    margin-top: 5px;\n    display: flow-root;\n    font-size: 14px;\n}\n\n.cardOpen {\n    display: inline-block;\n    width: 48%;\n    text-align: right;\n    padding: 1px;\n}\n\n.cardAction {\n    width: 48%;\n    display: inline-block;\n    padding: 1px;\n}\n\n.cardAction button {\n    width: 90px !important;\n    background: linear-gradient(90deg, rgba(73, 150, 238) 0%, rgba(37, 75, 119) 100%);\n    color: #fff;\n    height: 20px;\n    border-radius: 0 !important;\n    font-size: 12px;\n}\n\n.cardAction button:hover {\n    background: linear-gradient(90deg, rgba(37, 75, 119) 0%, rgba(73, 150, 238) 100%);\n    color: #fff;\n}\n\n.cardOpen button {\n    width: 90px !important;\n    background: linear-gradient(90deg, rgba(73, 150, 238) 0%, rgba(37, 75, 119) 100%);\n    color: #fff;\n    height: 20px;\n    border-radius: 0 !important;\n    font-size: 12px;\n\n}\n\n.cardOpen button:hover {\n    background: linear-gradient(90deg, rgba(37, 75, 119) 0%, rgba(73, 150, 238) 100%);\n    color: #fff;\n}\n\n.MuiDialog-root .MuiDialog-container .css-1t1j96h-MuiPaper-root-MuiDialog-paper {\n    background-color: #0F0E17 !important;\n    z-index: 9;\n    position: absolute;\n    display: flex;\n}\n\n.css-9ddj71-MuiInputBase-root-MuiOutlinedInput-root {\n    color: #fff !important;\n}\n\n.css-1t8l2tu-MuiInputBase-input-MuiOutlinedInput-input {\n    padding: 3px 15px !important;\n    color: #fff !important;\n\n}\n\n.filterItems {\n    margin-top: 20px;\n    display: flex;\n}\n\n.filterItems > div {\n    width: 75%;\n}\n\n.filterItems > div > div {\n    overflow: visible !important;\n    overflow-x: visible !important;\n    max-width: 100% !important;\n}\n\n.css-11u53oe-MuiSelect-select-MuiInputBase-input-MuiOutlinedInput-input {\n    padding: 2px 30px !important;\n    color: #fff !important;\n    overflow-x: hidden;\n    max-width: 110px !important;\n}\n\n.filterItems .css-1e8dhvr-MuiChip-root {\n    color: #fff !important;\n    padding-right: 10px;\n}\n\n.filterItems .css-hfutr2-MuiSvgIcon-root-MuiSelect-icon {\n    color: #fff !important;\n}\n\n.css-1d3z3hw-MuiOutlinedInput-notchedOutline > * {\n    border-color: #acabab !important;\n    border-radius: 0 !important;\n    color: #fff !important;\n}\n\n.addNewTicket button {\n    background: linear-gradient(90deg, rgba(73, 150, 238) 0%, rgba(37, 75, 119) 100%);\n    color: #fff;\n    border-radius: 0 !important;\n    text-align: left;\n    align-items: left;\n    height: 38px;\n}\n\n.addNewTicket button:hover {\n    background: linear-gradient(90deg, rgba(37, 75, 119) 0%, rgba(73, 150, 238) 100%);\n    color: #fff;\n}\n\n.searchBar input[type='text'] {\n    padding: 0;\n    padding-left: 15px;\n    margin-bottom: 0;\n    border: 1px solid #ccc;\n    border-radius: 0 !important;\n    background-color: #282B30;\n    color: #e1e1e1;\n}\n .buttons-bar > div > .sortBy .MuiFormControl-root {\n    height: 40px !important;\n    color: #ccc;\n    border: 1px solid #ccc;\n}\n\n.buttons-bar > div > .sortBy .MuiFormControl-root .MuiInputBase-root {\n    height: 40px !important;\n    color: #ccc;\n    background-color: #282B30;\n    font-size: 14px;\n}\n\n.sortBy .MuiFormControl-root .MuiFormLabel-root {\n    visibility: hidden;\n}\n\n.priority {\n    padding: 5px 10px;\n    width: 60px;\n    border-radius: 60px;\n    height: 20px !important;\n    text-align: center;\n}\n\n.priority.critical {\n    background-color: rgb(80, 31, 31);\n    height: 20px !important;\n    animation: blinker 1s linear infinite;\n    \n}\n\n\n.priority.open.alarm {\n    background-color: rgb(184, 70, 70);\n    height: 20px !important;\n    animation: blinker 1s linear infinite;\n}\n@keyframes blinker {\n    50% {\n        opacity: 0;\n    }\n}\n\n.priority.progress.alarm {\n    background-color: rgb(184, 70, 70);\n    height: 20px !important;\n}\n.priority.approval.alarm {\n    background-color: rgb(202, 200, 50);\n    height: 20px !important;\n}\n.priority.closed.alarm {\n    background-color: rgb(0, 135, 13);\n    height: 20px !important;\n}\n\n.priority.closed.warning {\n    background-color: rgb(0, 135, 13);\n    height: 20px !important;\n}\n.priority.warning{\n    background-color: rgb(138, 135, 59);\n    height: 20px !important;\n}\n\n\n\n.priority.medium {\n    background-color: rgb(206, 155, 62);\n}\n\n.priority.low {\n    background-color: rgb(132, 132, 42);\n}\n\n.selected .priority {\n    color: #fff;\n}\n\n.selected .priority.high {\n    background-color: rgb(184, 70, 70);\n}\n\n.selected .priority.medium {\n    background-color: rgb(206, 155, 62);\n}\n\n.selected .priority.low {\n    background-color: rgb(224, 224, 83);\n}\n\n.closeDialog button {\n    background: linear-gradient(90deg, rgba(73, 150, 238) 0%, rgba(37, 75, 119) 100%);\n    color: #fff;\n    border-radius: 0 !important;\n}\n\n.closeDialog button:hover {\n    background: linear-gradient(90deg, rgba(37, 75, 119) 0%, rgba(73, 150, 238) 100%);\n    color: #fff;\n}\n\n.sortBy .MuiFormControl-root .MuiInputBase-root .css-11u53oe-MuiSelect-select-MuiInputBase-input-MuiOutlinedInput-input {\n    padding-top: 0 !important;\n    padding-bottom: 0 !important;\n}\n\n.MuiPopover-root .css-1ka5eyc-MuiPaper-root-MuiMenu-paper-MuiPopover-paper {\n    background-color: #282B30 !important;\n    color: #ccc;\n}\n\n.ticket-container .css-mhc70k-MuiGrid-root>.MuiGrid-item {\n    padding-left: 0 !important;\n}\n\n@media screen and (max-width: 1265px) and (min-width: 1165px) {\n    .addNewTicket button {\n        /* width: 140px !important; */\n        font-size: 12px;\n        text-align: center;\n    }\n}\n\n@media screen and (max-width: 1164px) and (min-width: 1000px) {\n    .addNewTicket button {\n        width: 120px;\n        font-size: 9px;\n        text-align: center;\n    }\n}\n\n@media screen and (max-width: 1000px) and (min-width: 805px) {\n    .addNewTicket button {\n\n        font-size: 8px;\n        text-align: center;\n    }\n\n    .TicketingPage {\n        width: 100%;\n\n    }\n\n    .layoutContainer {\n        width: 100%;\n    }\n}\n\n@media screen and (max-width: 805px) and (min-width: 625px) {\n    .addNewTicket button {\n        width: 50px;\n        font-size: 6px;\n        text-align: center;\n    }\n\n}\n\n@media screen and (max-width: 1050px) and (min-width: 625px) {\n   \n    .cardPriority {\n        display: flow-root;\n        margin-top: 5px;\n        width: auto;\n        text-align: center;\n    }\n\n    .cardDate {\n        display: flex;\n        width: auto;\n    }\n\n    .cardOpen {\n        display: block;\n        text-align: center;\n    }\n\n    .cardAction {\n        display: block;\n        text-align: center;\n    }\n\n    .cardButtons {\n        justify-content: center;\n        align-items: center;\n        position: relative;\n        display: grid;\n        width: auto;\n    }\n\n    .cardDetails {\n        justify-content: center;\n        align-items: center;\n\n        display: grid;\n\n    }\n\n    .columnTitle {\n        font-size: 12px;\n    }\n\n    .ticketCount {\n        font-size: 8px;\n    }\n}\n\n@media screen and (max-width: 625px) {\n\n    .cardPriority {\n        display: flow-root;\n        margin-top: 5px;\n        width: auto;\n        text-align: center;\n    }\n\n    .cardDate {\n        display: flex;\n        width: auto;\n    }\n\n    .ticket-card {\n        text-align: center;\n    }\n\n    .cardOpen {\n        display: block;\n        text-align: center;\n    }\n\n    .cardAction {\n        display: block;\n        text-align: center;\n    }\n\n    .cardButtons {\n        justify-content: center;\n        align-items: center;\n        position: relative;\n        display: grid;\n        width: auto;\n    }\n\n    .cardDetails {\n        justify-content: center;\n        align-items: center;\n\n        display: grid;\n\n    }\n\n    .columnTitle {\n        font-size: 12px;\n    }\n\n    .ticketCount {\n        font-size: 8px;\n    }\n\n\n\n    .navb nav ul {\n        width: 100% !important;\n    }\n\n    .navb {\n        width: 100%;\n    }\n\n    .layoutContainer {\n        width: 120%;\n    }\n}\n\n@media screen and (max-width: 899px) {\n    .navb nav ul li {\n        display: inline-block;\n    }\n\n    .layoutContainer {\n        width: 120%;\n    }\n\n\n}\n\n@media screen and (min-width:768px) {\n    .MuiGrid-root.MuiGrid-grid-xs-12.MuiGrid-grid-sm-6.MuiGrid-grid-md-3.css-10voxkt-MuiGrid-root {\n        max-width: calc(25% - 5px);\n    }\n}\n\n@media screen and (max-width:768px) {\n    .MuiGrid-root.MuiGrid-grid-xs-12.MuiGrid-grid-sm-6.MuiGrid-grid-md-3.css-10voxkt-MuiGrid-root {\n        max-width: calc(50% - 5px);\n    }\n    \n    /* .ticketing-layout {\n        width: calc(100% - 2rem) !important;\n    \n    } */\n}\n\n\n@media screen and (min-width: 899px) {\n\n    .layoutContainer {\n        width: 100% !important;\n    }\n\n    .addNewTicket button {\n\n        text-align: center;\n    }\n\n\n}\n\n@media screen and (min-width: 1050px) {\n    .cardAction button {\n        margin: 2px;\n    }\n}\n\n@media screen and (max-width: 1165px) {\n    .addNewTicket button {\n        height: 38px !important;\n        font-size: 12px;\n        text-align: center;\n        width: 98%;\n        margin-bottom: 15px;\n    }\n\n}\n\n@media screen and (max-width: 600px) {\n    .firstPart {\n        display: inline-block;\n    }\n\n    .cardDescription {\n        display: inline-block;\n    }\n\n    .buttonsDetails {\n        display: inline-block;\n    }\n\n}\n\n.ticketing-layout {\n    position: relative;\n    height: calc(100% - 6rem);\n    /* min-height: 500px; */\n    /* width: calc(100% - 2rem) !important; */\n\n}\n.TicketingPage{\n    height: 100%;\n    position: relative;\n}\n\n.navb-item{\n    height: auto !important;\n}\n\n.TicketingPage > .buttons-bar {\n    padding-bottom: 10px;\n    height: auto;\n}\n\n.TicketingPage > .buttons-bar > div, .TicketingPage > .buttons-bar > div > *, .TicketingPage > .buttons-bar > div > div > * {\n    width: 100% !important;\n    width: -webkit-fill-available !important;\n    width: -moz-available !important;\n    height: 40px !important;\n    margin-bottom: 10px;\n}\n\n.TicketingPage .buttons-bar button , .TicketingPage .buttons-bar input, .TicketingPage .buttons-bar select  {\n    width: 100% !important;\n    height: 40px !important;\n    width: -webkit-fill-available !important;\n    width: -moz-available !important;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
